import { FAQ_DATA_RECEIVED, FAQ_SEARCH_DATA_RECEIVED } from './types';

export default function faq(state = [], action = {}){
  switch (action.type) {
    case FAQ_DATA_RECEIVED:
      return action.data
    case FAQ_SEARCH_DATA_RECEIVED:
      return action.data
    default:
      return state;
  }
}
